import React, { useEffect, useState, useRef } from "react";

const Error404 = () => {
    const gameContainer = useRef(null);
    const [score, setScore] = useState(0);
    const [timeLeft, setTimeLeft] = useState(30);

    useEffect(() => {
        let gameInterval;
        let timerInterval;
        const gameContainerElement = gameContainer.current;

        // Create a random position for the circle
        function getRandomPosition() {
            const gameContainerRect = gameContainerElement.getBoundingClientRect();
            const x = Math.random() * (gameContainerRect.width - 50);
            const y = Math.random() * (gameContainerRect.height - 50);
            return { x, y };
        }

        // Create a circle element
        function createCircle() {
            const circle = document.createElement("div");
            circle.classList.add("circle");

            const position = getRandomPosition();
            circle.style.left = `${position.x}px`;
            circle.style.top = `${position.y}px`;

            // Increment score when the circle is clicked
            circle.addEventListener("click", () => {
                setScore((prevScore) => prevScore + 1);
                gameContainerElement.removeChild(circle);
                createCircle(); // Create a new circle after clicking
            });

            gameContainerElement.appendChild(circle);
        }

        // Start the timer countdown
        function startTimer() {
            timerInterval = setInterval(() => {
                setTimeLeft((prevTime) => {
                    if (prevTime <= 1) {
                        clearInterval(timerInterval);
                        clearInterval(gameInterval);
                        alert(`Game over! Your final score is ${score}`);
                    }
                    return prevTime - 1;
                });
            }, 1000);
        }

        // Start the game
        function startGame() {
            gameInterval = setInterval(createCircle, 1000);
            startTimer();
        }

        startGame(); // Start the game when the component mounts

        return () => {
            // Clean up intervals when component is unmounted
            clearInterval(gameInterval);
            clearInterval(timerInterval);
        };
    }, [score]); // Dependency on score to ensure correct alert message

    return (
        <div>
            <h1 className="errTitle">Error 404</h1>
            <div className="game-container error404" ref={gameContainer} >
                <div id="score">Score: {score}</div>
                <div id="timer">Time: {timeLeft}</div>
            </div>
        </div>
    );
};

export default Error404;
